import React from 'react';

const Footer = () => {
    return (
        <footer class="footer footer-center p-4 bg-accent text-base-content z-10 ">
            <div>
                <p className='py-2 text-lg'>Copyright © 2022 - All right reserved by Najmul</p>
            </div>
        </footer>
    );
};

export default Footer;